import { render, staticRenderFns } from "./ActiveTable.vue?vue&type=template&id=898450ec&"
import script from "./ActiveTable.vue?vue&type=script&lang=ts&"
export * from "./ActiveTable.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports